module.exports = __webpack_public_path__ + "static/media/logo-mobile-icon.ed49f5ea.svg";